import {Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-preferred-contact',
  templateUrl: './preferred-contact.component.html'
})
export class PreferredContactComponent implements OnInit, OnDestroy {

  @Input() protected name: string;
  @Input() protected label: string;
  @Input() value: any = null;
  @Input() availableValues: Array<any>;
  @Input() nullValue: string;
  isOptionListOpened = false;

  @Output() update = new EventEmitter<any>();

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.closeOptionList();
    }
  }

  constructor(private eRef: ElementRef) {
  }

  ngOnInit() {
    this.emitUpdateEvent();
    this.setAvailableValues(this.availableValues);
  }

  ngOnDestroy() {
  }

  public setName(name): void {
    this.name = name;
  }

  public getName(): string {
    return this.name;
  }

  public setValue(value: any): void {
    this.value = value;
    this.closeOptionList();
    this.emitUpdateEvent();
  }

  public getValue(): any {
    return this.value;
  }

  public setNullValue(nullValue: string): void {
    this.nullValue = nullValue;
  }

  public setAvailableValues(availableValues: Array<any>): void {
    this.availableValues = availableValues;
  }

  public onUpdate(value: any): void {
    this.setValue(value);
    this.closeOptionList();
  }

  private emitUpdateEvent() {
    const updateObject = this.value;
    this.update.emit(updateObject);
  }

  public getValueToDisplay(value: any): string {
    let val = null;

    this.availableValues.forEach(value1 => {
      if (value1.value === value) {
        val = value1.label;
      }
    });

    return val === null ? this.nullValue : val;
  }

  public openOrCloseOptionList($event = null) {
    this.isOptionListOpened = !this.isOptionListOpened;
  }

  closeOptionList() {
    this.isOptionListOpened = false;
  }
}
